import { Framework } from '@/framework/instance';
import { IPoint, type OpenPluginType } from '@/version-types';
import { getContextMenuState } from './states/context-menu-state';
import { ContextMenuEvents, GetCustomContextMenuFn, IRenderContextMenuItemArgs } from './type';

export class ContextMenuPlugin extends Framework {
    /** 右键菜单位置信息 */
    positionInfo = {
        x: 0,
        y: 0,
        bottom: 0,
        right: 0,
        arrowMenuInRight: true,
    };
    /** 右键菜单激活信息 */
    activeInfo: IRenderContextMenuItemArgs = {
        activeLayer: null,
        pickLayer: null,
        isImageEditor: false,
        operateLayerType: '',
    };

    /** 自定义隐藏菜单项 */
    setHiddenContextMenu(hiddenContextMenuTypes: Array<string>) {
        getContextMenuState(this.identity).setHiddenContextMenuTypes(hiddenContextMenuTypes);
    }

    /** 注册获取自定义右键菜单配置的方法 */
    registerContextMenu(getCustomContextMenuFn: GetCustomContextMenuFn) {
        getContextMenuState(this.identity).setCustomContextMenuFn(getCustomContextMenuFn);
    }

    /** 注销获取自定义右键菜单配置的方法 */
    unregisterContextMenu() {
        getContextMenuState(this.identity).setCustomContextMenuFn(() => null);
    }

    /** 禁用右键菜单 */
    disableMenu() {
        getContextMenuState(this.identity).setDisableMenu(true);
    }

    /** 启用右键菜单 */
    enableMenu() {
        getContextMenuState(this.identity).setDisableMenu(false);
    }

    /** 监听打开插件事件 */
    onOpenPlugin(cb: (plugin: OpenPluginType) => void) {
        const handler = this.framework.events.on(ContextMenuEvents.openPlugin, cb);
        return () => this.framework.events.off(handler);
    }

    /** 打开插件 */
    openPlugin(plugin: OpenPluginType) {
        this.framework.events.emit(ContextMenuEvents.openPlugin, plugin);
    }

    /** 监听 进入ai生图的入口事件 */
    onAiGenerateImageEnter(cb: (entrance: string) => void) {
        const handler = this.framework.events.on(ContextMenuEvents.aiGenerateImageEnter, cb);
        return () => this.framework.events.off(handler);
    }

    /** 监听右键菜单状态事件 */
    onState(cb: (isShow: boolean) => void) {
        const handler = this.framework.events.on(ContextMenuEvents.stateChange, cb);
        return () => this.framework.events.off(handler);
    }

    /** 设置右键菜单状态 */
    setState(isShow: boolean) {
        this.framework.events.emit(ContextMenuEvents.stateChange, isShow);
    }

    /** 设置是否显示高级(AI)操作 */
    setShowAdvancedAIOperation(showAdvancedAIOperation: boolean) {
        getContextMenuState(this.identity).setShowAdvancedAIOperation(showAdvancedAIOperation);
    }

    /** 监听打开我的空间模态框事件 */
    onAddImage(callback: () => void, weight = 0) {
        const handler = this.framework.events.on(ContextMenuEvents.addImage, callback, weight);
        return () => this.framework.events.off(handler);
    }

    /** 添加图片 */
    addImage() {
        this.framework.events.emit(ContextMenuEvents.addImage);
    }

    /** 监听保存到我的空间事件 */
    onSaveToMySpace(callback: () => void, weight = 0) {
        const handler = this.framework.events.on(ContextMenuEvents.saveToMySpace, callback, weight);
        return () => this.framework.events.off(handler);
    }

    /** 添加到我的空间 */
    saveToMySpace() {
        this.framework.events.emit(ContextMenuEvents.saveToMySpace);
    }

    /** 关闭右键菜单 */
    close() {
        this.framework.events.emit(ContextMenuEvents.close);
    }

    /** 监听右键菜单关闭事件 */
    onClose(cb: () => void) {
        const handler = this.framework.events.on(ContextMenuEvents.close, cb);
        return () => this.framework.events.off(handler);
    }

    /** 监听右键菜单打开事件 */
    onShow(cb: (point: IPoint) => void) {
        const handler = this.framework.events.on(ContextMenuEvents.show, cb);
        return () => this.framework.events.off(handler);
    }

    /** 展示右键菜单 */
    show(point: IPoint) {
        this.framework.events.emit(ContextMenuEvents.show, point);
    }
}
